﻿window.cObjets = function (bddRef) {

    this.save_historique = "1"
    var lstObjets = []
    this.mGetLstObjets = function () { return lstObjets }
    //action: "save","supp"
    //ATTENTION, on ne peut pas créer des lignes de table interdépendante entre elle (ex, si on crée le doc_cpt, les doc_cpt_ligne ne seront pas rattaché parce que leur id_doc_cpt ne sera pas initialisé)
    this.mAddData = function (lstData, action) {
        lstData.forEach(function (data) {
            var nomTable = bddRef.getObjet(data).mGetTable().nom
            if (nomTable == "fichier_joint" || nomTable == "utilisateur") throw "Enable to save table 'utilisateur' or 'fichier_joint'"
            lstObjets.push({
                idx: lstObjets.length,
                nom_table: nomTable,
                action: action,
                data: data
            })
        })
    }

    this.idTableRef = null
    this.idRef = null
    this.id_type_action = null
    this.nomBase = null
    this.mSave = function (funcOk, funcAlways, funcKo, async, option) {
        if (typeof option == 'undefined') option = {}
        bddRef.mAjaxCall({
            command: "saveobjets",
            save_historique: this.save_historique,
            id_table_ref: this.idTableRef,
            id_ref: this.idRef,
            id_type_action:this.id_type_action,
            lstobjets: lstObjets,
            async: ((typeof async != 'undefined') ? async : true)
        }, function (data) {
            //on enlève les objets supprimé de la base local
            if (data.erreur_objets == "1") {
                if (funcKo) funcKo(data)
                return
            }
            lstObjets.filter(function (o) { return o.action == "supp" || o.action == "suppdef" }).forEach(function (itemData) {
                var obj = bddRef.getObjet(itemData.data)
                bddRef.mDelItemData(obj.mGetTable().nom, itemData.data)
            })
            if (typeof data.ids != 'undefined') data.ids.forEach(function (ele) {
                var obj = bddRef.getObjet(lstObjets[ele.idx].data)
                if (typeof ele.dcr != 'undefined') obj.data.dcr = ele.dcr
                if (typeof ele.dmo != 'undefined') obj.data.dmo = ele.dmo
                if (obj.cle() == null) {
                    obj.data[obj.nomCle] = ele.id
                    if (typeof option.disableTriggerModif == 'undefined' || !option.disableTriggerModif) bddRef.triggerFunctionOnModifiedItemData(obj.mGetTable().nom, "new", obj.data)
                } else {
                    if (typeof option.disableTriggerModif == 'undefined' || !option.disableTriggerModif) bddRef.triggerFunctionOnModifiedItemData(obj.mGetTable().nom, "modif", obj.data)
                }
            })
            if (funcOk) funcOk(data)
        },
            function () { if (funcAlways) funcAlways() },
            function (data) { if (funcKo) funcKo(data) });
    }

}